import React, { useEffect, useRef, useState } from 'react';
import { FormGroup, Label, ModalBody, ModalFooter, Spinner, ModalHeader, Input } from 'reactstrap';
import moment from 'moment';
import { Col, Row, Button as Btn, Modal as Mdl } from 'reactstrap';
import { insert, selectValues, update, validarCNPJ, validarCPF } from '../../../utils/fc';
import Select from '../../Template/Input/Select';
import powerAppsApi from '../../../services/powerapps';
import oikosApi from '../../../services/oikos';
import qs from 'qs';
import { notifyError, notifySuccess } from '../../../utils/notify';
import { notify } from 'node-notifier';
import { pdfjs } from 'react-pdf';
import {
  completarLacunasComReceita,
  extrairDadosFavorecido,
  somenteDigitos,
  sugerirTipoPix,
} from './extrairFavorecidoAnexo';

async function textoDeAnexo(item) {
  if (item?.url) {
    const resposta = await fetch(item.url);
    if (!resposta.ok) throw new Error('anexo');
    const buffer = await resposta.arrayBuffer();
    return textoDoPdf(new File([buffer], 'anexo.pdf', { type: 'application/pdf' }));
  }
  const arquivo = item?.data || item;
  if (!arquivo || typeof arquivo.arrayBuffer !== 'function') return '';
  return textoDoPdf(arquivo);
}

async function textoDoPdf(file) {
  const nome = String(file.name || file.path || '').toLowerCase();
  const tipo = String(file.type || '').toLowerCase();
  if (tipo.startsWith('image/')) return '';
  if (tipo && tipo !== 'application/pdf' && !nome.endsWith('.pdf')) return '';

  const data = new Uint8Array(await file.arrayBuffer());
  const doc = await pdfjs.getDocument({ data }).promise;
  try {
    const paginas = [];
    for (let i = 1; i <= doc.numPages; i += 1) {
      const page = await doc.getPage(i);
      const content = await page.getTextContent();
      const linhas = [];
      let linha = '';
      let y = null;
      content.items.forEach((item) => {
        const itemY = item.transform ? item.transform[5] : null;
        const pedaco = item.str || '';
        if (y !== null && itemY !== null && Math.abs(itemY - y) > 3) {
          if (linha.trim()) linhas.push(linha.trim());
          linha = pedaco;
        } else {
          linha = linha ? `${linha} ${pedaco}` : pedaco;
        }
        if (itemY !== null) y = itemY;
      });
      if (linha.trim()) linhas.push(linha.trim());
      paginas.push(linhas.join('\n'));
    }
    return paginas.join('\n');
  } finally {
    if (doc.destroy) await doc.destroy();
  }
}

const ModalFormAddFavBordero = ( props ) => {

  const [addFavModal, setAddFavModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [identificador, setIdentificador] = useState('');
  const [banco, setBanco] = useState('');
  const [agencia, setAgencia] = useState('');
  const [numeroConta, setNumeroConta] = useState('');
  const [pix, setPix] = useState('');
  const [telefoneFixo, setTelefoneFixo] = useState('');
  const [celular, setCelular] = useState('');
  const [tipoPix, setTipoPix] = useState({});
  const [kaminoId, setKaminoId] = useState('');
  const [selectTipoPix, setSelectTipoPix] = useState([]);
  const [page, setPage] = useState(1);
  const [sugerindo, setSugerindo] = useState(false);

  const handleClickOpenAddFavModal = () => {
    setPage(1);
    setAddFavModal(true);
  };
  const handleClickCloseAddFavModal = () => setAddFavModal(false);

  function checkCamposObrigatoriosContrForn() {

    if (!props.isPf) {
      if (nome === '' || !nome) {
        notifyError('Nome é obrigatório');
        return false
      }

      if (email === '' || !email) {
        notifyError('E-mail é obrigatório');
        return false
      }

      if (String(identificador).trim() === '' || !identificador) {
        notifyError('CPF/CNPJ é obrigatório');
        return false
      }

      if (telefoneFixo === '' || !telefoneFixo) {
        notifyError('Telefone é obrigatório');
        return false
      }

      if (telefoneFixo?.length < 9) {
        notifyError('Telefone incompleto');
        return false
      }
    } else if (props.isPf) {
      if (nome === '' || !nome) {
        notifyError('Nome é obrigatório');
        return false
      }

      if (email === '' || !email) {
        notifyError('E-mail é obrigatório');
        return false
      }

      if (String(identificador).trim() === '' || !identificador) {
        notifyError('CPF/CNPJ é obrigatório');
        return false
      }

      if ((celular === '' || !celular) && (telefoneFixo === '' || !telefoneFixo)) {
        notifyError('Preencha o campo de telefone fixo ou celular');
        return false
      }

      if ((!(telefoneFixo === '' || !telefoneFixo) && telefoneFixo.length < 9) || (!(celular === '' || !celular) && celular.length < 9)) {
        notifyError('Telefone incompleto');
        return false
      }
    }


    return true
  }

  const verificaIdentificador = async (isPf) => {
    var exists = false;

    if (isPf) {
      const pf = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'pf',
        data: {
          pf_cpf: identificador,
        }
      })}`);

      if (pf.data[0]) {
        exists = true
      };
    }

    else {
      const pj = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'pj',
        data: {
          pj_cnpj: identificador,
        }
      })}`);

      if (pj.data[0]) {
        exists = true
      };
    }

    return exists;
  }

  const handleSubmit = async () => {
    setIsLoading(true);

    const existFav = await verificaIdentificador(props.isPf);
    if (existFav) {
      setIsLoading(false);
      return alert('Favorecido já existe');
    }

    const camposOk = checkCamposObrigatoriosContrForn();
    if (!camposOk) {
      setIsLoading(false);
      return;
    }

    if (props.isPf) {
      const pfBody = {
          action: 'insert',
          table: 'pf',
          data: {
          pf_nomeExibicao: nome,
          pf_emailProf: email,
          pf_cpf: identificador,
          pf_contaBanco: banco,
          pf_contaAgencia: agencia,
          pf_contaNum: numeroConta,
          pf_chavePix: pix,
          pixTp_id: tipoPix.value,
          pf_telFixoProf: telefoneFixo ? telefoneFixo.trim() : undefined,
          pf_celProf: celular ? celular.trim() : undefined,
        }
      }

      const cpfValido = await validarCPF(identificador);
      if (!cpfValido) {
        setIsLoading(false);
        return alert('CPF inválido');
      }

      const pfCreated = await oikosApi.post('/', pfBody)

      const kaminoBody = {
        acao: 'kamino_salvar_pessoa',
        table: 'pf',
        id: pfCreated.data[0].pf_id,
      }

      const res = await powerAppsApi.post('/', kaminoBody, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'multipart/form-data',
        },
      })

      if (res.status === 200) {
        notifySuccess('Informações enviadas para o banco!');
      }

    } else {

      const pjBody = {
        action: 'insert',
        table: 'pj',
        data: {
          pj_nomefanta: nome,
          pj_emailPrin: email,
          pj_cnpj: identificador,
          pj_contaBanco: banco,
          pj_contaAgencia: agencia,
          pj_contaNum: numeroConta,
          pj_chavePix: pix,
          pixTp_id: tipoPix.value,
          pj_telPrin: telefoneFixo.trim(),
        }
      }

      const cnpjValido = await validarCNPJ(identificador);
      if (!cnpjValido) {
        setIsLoading(false);
        return alert('CNPJ inválido');
      }

      const pjCreated = await oikosApi.post('/', pjBody)

      const kaminoBody = {
        acao: 'kamino_salvar_pessoa',
        table: 'pj',
        id: pjCreated.data[0].pj_id,
      }

      const res = await powerAppsApi.post('/', kaminoBody, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'multipart/form-data',
        },
      })

      if (res.status === 200) {
        notifySuccess('Informações enviadas para o banco!');
      }
    }

    setIsLoading(false);

    props.getFavs(props.isPf);
  }

  async function getCNPJInfo(cnpj) {
    const res = await powerAppsApi.post('/', {
      acao: 'get_pj',
      cnpj: cnpj
    }, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'multipart/form-data',
      },
    });
    console.log(res);
    return res;
  }

  const handleNextPage = async () => {
    if (page === 2) {
      return
    }

    // if else para verificar se favorecido já existe
    if (props.isPf) {
      const queryString = `/?${qs.stringify({
        action: 'get',
        table: 'pf',
        fields: {
          "(SELECT REPLACE(REPLACE(REPLACE(pf_cpf, '.', ''), '-', ''), ' ', '') FROM pf pessoaFisica WHERE pf.pf_id = pessoaFisica.pf_id)" : "pf_cpf"
        },
        data: {pf_ativo: 1},
      })}`;

      const resp = await oikosApi.get(queryString);

      console.log(String(identificador).replaceAll(".", "").replaceAll("-", "").trim());

      const findedPF = resp.data.find( e => e.pf_cpf === String(identificador).replaceAll(".", "").replaceAll("-", "").trim() );

      if (findedPF) {
        props.setSelectedFav({value: findedPF.pf_id, label: findedPF.pf_nomeExibicao, ...findedPF})
        if (props.setFavInfo) {
          props.setFavInfo({value: findedPF.pf_id, label: findedPF.pf_nomeExibicao, ...findedPF})
        }
        handleClickCloseAddFavModal();
        return
      }

      console.log(findedPF);
    } else {
      const queryString = `/?${qs.stringify({
        action: 'get',
        table: 'pj',
        fields: {
          "(SELECT REPLACE(REPLACE(REPLACE(REPLACE(pj_cnpj, '.', ''), '-', ''), '/', ''), ' ', '') FROM pj pessoaJuridica WHERE pj.pj_id = pessoaJuridica.pj_id)" : "pj_cnpj"
        },
        data: {pj_ativo: 1},
      })}`;

      const resp = await oikosApi.get(queryString);

      console.log(String(identificador).replaceAll(".", "").replaceAll("-", "").replaceAll("/", "").trim());

      const findedPJ = resp.data.find( e => e.pj_cnpj === String(identificador).replaceAll(".", "").replaceAll("-", "").replaceAll("/", "").trim());

      if (findedPJ) {
        props.setSelectedFav({value: findedPJ.pj_id, label: findedPJ.pj_nomefanta, ...findedPJ})
        if (props.setFavInfo) {
          props.setFavInfo({value: findedPJ.pj_id, label: findedPJ.pj_nomefanta, ...findedPJ})
        }
        handleClickCloseAddFavModal();
        return
      }
    }

    // if para buscar dados da receita federal para PJ
    if (!props.isPf) {
      const cnpjInfo = await getCNPJInfo(String(identificador).replaceAll(".", "").replaceAll("-", "").replaceAll("/", "").trim());
      const pjData = cnpjInfo.data;
      if (!pjData || pjData.status === "ERROR") {
        return notifyError('CNPJ não encontrado na Receita Federal');
      }
      setNome(pjData.fantasia);
      setEmail(pjData.email);
      setTelefoneFixo(pjData.telefone);
    }

    setPage(page + 1)
  }

  const handlePrevPage = () => {
    if (page === 1) {
      return
    }
    setPage(page - 1)
  }

  async function localizarFavorecido(doc, isPf) {
    if (isPf) {
      const queryString = `/?${qs.stringify({
        action: 'get',
        table: 'pf',
        fields: {
          "(SELECT REPLACE(REPLACE(REPLACE(pf_cpf, '.', ''), '-', ''), ' ', '') FROM pf pessoaFisica WHERE pf.pf_id = pessoaFisica.pf_id)" : "pf_cpf"
        },
        data: { pf_ativo: 1 },
      })}`;
      const resp = await oikosApi.get(queryString);
      const limpo = somenteDigitos(doc);
      return (resp.data || []).find((pessoa) => somenteDigitos(pessoa.pf_cpf) === limpo) || null;
    }

    const queryString = `/?${qs.stringify({
      action: 'get',
      table: 'pj',
      fields: {
        "(SELECT REPLACE(REPLACE(REPLACE(REPLACE(pj_cnpj, '.', ''), '-', ''), '/', ''), ' ', '') FROM pj pessoaJuridica WHERE pj.pj_id = pessoaJuridica.pj_id)" : "pj_cnpj"
      },
      data: { pj_ativo: 1 },
    })}`;
    const resp = await oikosApi.get(queryString);
    const limpo = somenteDigitos(doc);
    return (resp.data || []).find((pessoa) => somenteDigitos(pessoa.pj_cnpj) === limpo) || null;
  }

  const sugerirDosAnexos = async () => {
    const anexos = props.anexos || [];
    if (!anexos.length) {
      notifyError('Anexe o documento de cobrança ou a nota fiscal antes de sugerir.');
      return;
    }

    setSugerindo(true);
    try {
      const partes = [];
      let falhaDownload = false;
      for (const item of anexos) {
        try {
          partes.push(await textoDeAnexo(item));
        } catch (erro) {
          if (item?.url) falhaDownload = true;
          partes.push('');
        }
      }

      const texto = partes.filter(Boolean).join('\n');
      const extraido = extrairDadosFavorecido(texto);
      const docPdf = props.isPf ? extraido.cpf : extraido.cnpj;
      const docDigitado = somenteDigitos(identificador);
      let doc = '';
      if (docPdf && (props.isPf ? validarCPF(docPdf) : validarCNPJ(docPdf))) doc = docPdf;
      else if (docDigitado && (props.isPf ? validarCPF(docDigitado) : validarCNPJ(docDigitado))) doc = docDigitado;

      if (!texto.trim() && falhaDownload && !doc) {
        notifyError('Não foi possível ler o PDF já salvo nesta conta.');
        return;
      }
      if (!texto.trim() && props.isPf) {
        notifyError('O PDF não tem texto selecionável. Se for uma imagem escaneada, preencha o cadastro manualmente.');
        return;
      }
      if (!texto.trim() && !doc) {
        notifyError('O PDF não tem texto selecionável e não há CNPJ para consultar.');
        return;
      }

      if ((docPdf || docDigitado) && !doc) {
        notifyError(props.isPf ? 'CPF lido no anexo não é válido.' : 'CNPJ lido no anexo não é válido.');
      }

      if (doc) {
        const jaExiste = await localizarFavorecido(doc, props.isPf);
        if (jaExiste) {
          const id = props.isPf ? jaExiste.pf_id : jaExiste.pj_id;
          const label = props.isPf ? jaExiste.pf_nomeExibicao : jaExiste.pj_nomefanta;
          const selecionado = { value: id, label, ...jaExiste };
          props.setSelectedFav(selecionado);
          if (props.setFavInfo) props.setFavInfo(selecionado);
          notifySuccess('Este favorecido já está cadastrado e foi selecionado.');
          handleClickCloseAddFavModal();
          return;
        }
      }

      let lacunas = {
        nome: extraido.nome,
        email: extraido.email,
        telefone: extraido.telefone || extraido.celular,
        consultou: false,
      };
      let receitaFalhou = false;
      if (!props.isPf && doc) {
        try {
          const resposta = await getCNPJInfo(doc);
          const receita = resposta?.data;
          if (!receita || receita.status === 'ERROR') {
            receitaFalhou = true;
          } else {
            lacunas = completarLacunasComReceita({
              nome: extraido.nome,
              email: extraido.email,
              telefone: extraido.telefone || extraido.celular,
            }, receita);
          }
        } catch (erro) {
          receitaFalhou = true;
        }
      }

      const nomeFinal = lacunas.nome || '';
      const emailFinal = lacunas.email || '';
      const telefoneFinal = props.isPf ? (extraido.telefone || '') : (lacunas.telefone || '');
      const celularFinal = extraido.celular || '';
      const achouNoPdf = Boolean(
        docPdf || extraido.nome || extraido.email || extraido.telefone || extraido.celular
        || extraido.banco || extraido.agencia || extraido.conta || extraido.pix
      );
      const achouNaApi = Boolean(lacunas.consultou && (lacunas.nome || lacunas.email || lacunas.telefone));
      if (!achouNoPdf && !achouNaApi) {
        notifyError('Não encontrei dados do favorecido nesses anexos.');
        return;
      }

      if (docPdf) setIdentificador(docPdf);
      if (nomeFinal) setNome(nomeFinal);
      if (emailFinal) setEmail(emailFinal);
      if (telefoneFinal) setTelefoneFixo(telefoneFinal);
      if (celularFinal) setCelular(celularFinal);
      if (extraido.banco) setBanco(String(extraido.banco).slice(0, 3));
      if (extraido.agencia) setAgencia(extraido.agencia);
      if (extraido.conta) setNumeroConta(extraido.conta);
      if (extraido.pix) {
        setPix(extraido.pix);
        let opcoes = selectTipoPix;
        if (!opcoes.length) {
          opcoes = await selectValues('pixTp', 'pixTp_id', 'pixTp_nome', { pixTp_ativo: 1 });
          setSelectTipoPix(opcoes);
        }
        const tipo = sugerirTipoPix(extraido.pix, opcoes);
        if (tipo) setTipoPix(tipo);
      }
      setPage(2);

      if (!props.isPf && lacunas.consultou && !texto.trim()) {
        notifySuccess('O PDF não tinha texto selecionável. Nome, e-mail e telefone vieram da consulta de CNPJ. Revise antes de adicionar.');
      } else if (!props.isPf && lacunas.consultou) {
        notifySuccess('Dados sugeridos. O que o PDF não trouxe de nome, e-mail ou telefone veio da consulta de CNPJ. Revise antes de adicionar.');
      } else if (!props.isPf && !doc) {
        notifySuccess('Preenchi o que o PDF trouxe. Sem CNPJ, a consulta da Receita não rodou.');
      } else if (!props.isPf && receitaFalhou) {
        notifySuccess('Preenchi o que o PDF trouxe. A consulta de CNPJ não retornou o restante.');
      } else {
        notifySuccess('Dados sugeridos a partir do PDF. Revise antes de adicionar.');
      }
    } catch (erro) {
      notifyError('Não foi possível ler os anexos.');
    } finally {
      setSugerindo(false);
    }
  };

  const preloading = async () => {
    const getSelectTipoPix = await selectValues('pixTp', 'pixTp_id', 'pixTp_nome', {pixTp_ativo: 1})
    setSelectTipoPix(getSelectTipoPix)
  }

  useEffect(() => {
    preloading()
  },[])

  return (
    <>
      <Btn
        size="sm"
        color="link"
        className="ml-2 px-0"
        onClick={(e)=>{
          e.preventDefault();
          handleClickOpenAddFavModal();
        }}
      >
        Adicionar nova {(props.isPf) ?  'PF' : 'PJ' }
      </Btn>
      {(props.isPf) &&
        <Mdl
          centered={false}
          isOpen={addFavModal}
          toggle={handleClickCloseAddFavModal}
          zIndex={10000}
        >
          <ModalHeader
          >
            Adicionar
          </ModalHeader>
          <ModalBody>
            {props.anexos && (
              <Btn
                type="button"
                color="link"
                className="px-0 mb-2"
                disabled={sugerindo}
                onClick={sugerirDosAnexos}
              >
                {sugerindo ? <Spinner size="sm" /> : 'Sugerir a partir dos anexos'}
              </Btn>
            )}
            {page === 1 ?
            <FormGroup>
              <Label>
                CPF
              </Label>
              <Input
                value={identificador}
                onChange={e => setIdentificador(e.target.value)}
              />
            </FormGroup> :
            <FormGroup>
              <Label>
                Nome
              </Label>
              <Input
                value={nome}
                onChange={e => setNome(e.target.value)}
              />
              <Label>
                E-mail
              </Label>
              <Input
                type='email'
                value={email}
                onChange={e => setEmail(e.target.value)}
              />
              <Label>
                CPF
              </Label>
              <Input
                value={identificador}
                onChange={e => setIdentificador(e.target.value)}
              />
              <Label>
                Telefone fixo
              </Label>
              <Input
                value={telefoneFixo}
                onChange={e => setTelefoneFixo(e.target.value)}
              />
              <Label>
                Celular
              </Label>
              <Input
                value={celular}
                onChange={e => setCelular(String(e.target.value))}
              />
              <Label>
                Código do banco
              </Label>
              <Input
                value={banco}
                onChange={e => {
                  if (e.target.value.length > 3) {
                    return;
                  }
                  setBanco(e.target.value)
                }}
              />
              <Label>
                Agência
              </Label>
              <Input
                value={agencia}
                onChange={e => setAgencia(e.target.value)}
              />
              <Label>
                Número da conta
              </Label>
              <Input
                value={numeroConta}
                onChange={e => setNumeroConta(e.target.value)}
              />
              <Label>
                PIX
              </Label>
              <Input
                value={pix}
                onChange={e => setPix(e.target.value)}
              />
              <Label>
                Tipo PIX
              </Label>
              <Select
                className="basic-single"
                classNamePrefix="select"
                isClearable={true}
                isSearchable={true}
                options={selectTipoPix}
                value={tipoPix}
                onChange={(e) => {
                  setTipoPix(e)
                }}
              />
              <Label>
                Identificação Kamino
              </Label>
              <Input
                type='number'
                value={kaminoId}
                onChange={e => setKaminoId(e.target.value)}
              />
            </FormGroup>
            }
          </ModalBody>
          <ModalFooter>
            <div className="d-flex justify-content-between" style={{width: '100%'}}>
              <div>
                <Btn
                  type="button"
                  onClick={handlePrevPage}
                  color="light"
                  className="waves-effect"
                  style={{marginRight: '10px'}}
                >
                  Anterior
                </Btn>
                <Btn
                  type="button"
                  onClick={handleNextPage}
                  color="light"
                  className="waves-effect"
                >
                  Próximo
                </Btn>
              </div>
              <div>
                <Btn
                  type="button"
                  onClick={handleClickCloseAddFavModal}
                  color="light"
                  className="waves-effect"
                  style={{marginRight: '10px'}}
                >
                  Cancelar
                </Btn>
                {isLoading && page === 2 ?
                <Btn type="button" disabled><Spinner /></Btn> :
                (!isLoading && page === 2) ?
                <Btn
                  type="button"
                  color="primary"
                  className="waves-effect waves-light"
                  onClick={async () => {
                    //insOrUp( 'projStake', addStakeProjData)
                    console.log('inseriu');
                    await handleSubmit()
                    handleClickCloseAddFavModal();
                  }
                  }
                >
                  Adicionar
                </Btn> :
                <></>
                }
              </div>
            </div>
          </ModalFooter>
        </Mdl>
      }
      {
        (!props.isPf) &&
        <Mdl
          centered={false}
          isOpen={addFavModal}
          toggle={handleClickCloseAddFavModal}
          zIndex={10000}
        >
          <ModalHeader
          >
            Adicionar
          </ModalHeader>
          <ModalBody>
            {props.anexos && (
              <Btn
                type="button"
                color="link"
                className="px-0 mb-2"
                disabled={sugerindo}
                onClick={sugerirDosAnexos}
              >
                {sugerindo ? <Spinner size="sm" /> : 'Sugerir a partir dos anexos'}
              </Btn>
            )}
            {page === 1 ?
            <FormGroup>
              <Label>
                CNPJ
              </Label>
              <Input
                value={identificador}
                onChange={e => setIdentificador(e.target.value)}
              />
            </FormGroup>:
            <FormGroup>
              <Label>
                Nome Fantasia
              </Label>
              <Input
                value={nome}
                onChange={e => setNome(e.target.value)}
              />
              <Label>
                E-mail
              </Label>
              <Input
                value={email}
                onChange={e => setEmail(e.target.value)}
              />
              <Label>
                CNPJ
              </Label>
              <Input
                value={identificador}
                onChange={e => setIdentificador(e.target.value)}
              />
              <Label>
                Telefone principal
              </Label>
              <Input
                value={telefoneFixo}
                onChange={e => setTelefoneFixo(String(e.target.value))}
              />
              <Label>
                Código do banco
              </Label>
              <Input
                type='number'
                value={banco}
                onChange={e => {
                  if (e.target.value.length > 3) {
                    return;
                  }
                  setBanco(e.target.value)
                }}
              />
              <Label>
                Agência
              </Label>
              <Input
                value={agencia}
                onChange={e => setAgencia(e.target.value)}
              />
              <Label>
                Número da conta
              </Label>
              <Input
                value={numeroConta}
                onChange={e => setNumeroConta(e.target.value)}
              />
              <Label>
                PIX
              </Label>
              <Input
                value={pix}
                onChange={e => setPix(e.target.value)}
              />
              <Label>
                Tipo PIX
              </Label>
              <Select
                className="basic-single"
                classNamePrefix="select"
                isClearable={true}
                isSearchable={true}
                options={selectTipoPix}
                value={tipoPix}
                onChange={(e) => {
                  setTipoPix(e)
                }}
              />
              <Label>
                Identificação Kamino
              </Label>
              <Input
                type='number'
                value={kaminoId}
                onChange={e => setKaminoId(e.target.value)}
              />
            </FormGroup>
            }
          </ModalBody>
          <ModalFooter>
            <div className="d-flex justify-content-between" style={{width: '100%'}}>
              <div>
                <Btn
                  type="button"
                  onClick={handlePrevPage}
                  color="light"
                  className="waves-effect"
                  style={{marginRight: '10px'}}
                >
                  Anterior
                </Btn>
                <Btn
                  type="button"
                  onClick={handleNextPage}
                  color="light"
                  className="waves-effect"
                >
                  Próximo
                </Btn>
              </div>
              <div>
                <Btn
                  type="button"
                  onClick={handleClickCloseAddFavModal}
                  color="light"
                  className="waves-effect"
                  style={{marginRight: '10px'}}
                >
                  Cancelar
                </Btn>
                {(isLoading && page === 2) ?
                  <Btn type="button" disabled><Spinner /></Btn> :
                (!isLoading && page === 2) ?
                  <Btn
                    type="button"
                    color="primary"
                    className="waves-effect waves-light"
                    onClick={async () => {
                      //insOrUp( 'projStake', addStakeProjData)
                      console.log('inseriu');
                      await handleSubmit()
                      handleClickCloseAddFavModal();
                    }
                    }
                  >
                    Adicionar
                  </Btn> :
                  <></>
                }
              </div>
            </div>
          </ModalFooter>
        </Mdl>
      }
    </>
  )
}

export default ModalFormAddFavBordero;
